/* This file is autogenerated, see readme.md for instructions */
import ColorPickerAltSvgIcon from '@bloomreach/banana-theme/icons/color-picker-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ColorPickerAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ColorPickerAltSvgIcon />
    </Icon>
  );
});

ColorPickerAltIcon.displayName = 'ColorPickerAltIcon';

export default ColorPickerAltIcon;
